module.exports = __webpack_public_path__ + "static/media/Illus-Employee_4.f3dcb0ad.png";